<template>
  <v-row justify="center">
    <v-dialog
      v-model="isVisible"
      max-width="360"
      persistent
      scrollable
    >
      <v-card>
        <v-toolbar
          flat
          height="80"
          max-height="80"
        >
          <v-avatar class="indigo">
            <v-icon dark>
              {{ $t('Pos.AddProductByBarcodeDialog.Toolbar.Icon') }}
            </v-icon>
          </v-avatar>

          <v-toolbar-title class="pl-3">
            <div class="body-3">
              {{ $t('Pos.AddProductByBarcodeDialog.Toolbar.Title') }}
            </div>

            <div class="text-caption">
              {{ $t('Pos.AddProductByBarcodeDialog.Toolbar.Subtitle') }}
            </div>
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            icon
            @click="closeDialog"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider />

        <v-card-text class="pa-0">
          <v-container fluid>
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  v-if="visible"
                  v-model="barcodeModel"
                  v-mask="'#############'"
                  :error-messages="errorMsg"
                  :hint="$t('Pos.AddProductByBarcodeDialog.Field.Hint')"
                  :label="$t('Pos.AddProductByBarcodeDialog.Field.Label')"
                  autofocus
                  clearable
                  filled
                  hide-details="auto"
                  @input="onBarcodeModelChange"
                  @keyup.enter="setBarcode"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />

          <v-btn
            class="light-blue--text text--darken-1"
            outlined
            text
            @click="closeDialog"
          >
            {{ $t('Common.Button.Cancel').toLocaleUpperCase($i18n.locale) }}
          </v-btn>

          <v-btn
            :disabled="loading || barcodeModel?.length !== 13"
            :loading="loading"
            class="white--text"
            color="green"
            @click="setBarcode"
          >
            {{ $t('Common.Button.Ok').toLocaleUpperCase($i18n.locale) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import AppData from '@/mixins/appdata'
import DialogVisible from '@/mixins/dialogVisible.js'

export default {
  name      : 'AddProductByBarcodeDialog',
  components: {},
  mixins    : [AppData, DialogVisible],
  props     : {
    barcodeListener: {
      type   : Object,
      default: undefined
    }
  },
  data() {
    return {
      loading     : false,
      barcodeModel: '',
      errorMsg    : ''
    }
  },
  computed: {},
  watch   : {
    isVisible(val) {
      this.loading = false
      this.barcodeModel = ''
      this.errorMsg = ''

      this.$bus.$off('cart:product-by-barcode-added', this.onProductAdded)
      this.$bus.$off('cart:product-by-barcode-not-added', this.onProductNotAdded)

      if (val) {
        this.$bus.$on('cart:product-by-barcode-added', this.onProductAdded)
        this.$bus.$on('cart:product-by-barcode-not-added', this.onProductNotAdded)
      }
    }
  },
  methods: {
    onProductAdded(product) {
      this.loading = false
      this.closeDialog()
    },

    onProductNotAdded() {
      this.errorMsg = this.$t('Pos.AddProductByBarcodeDialog.Field.Error')
      this.loading = false
    },

    onBarcodeModelChange() {
      this.errorMsg = ''
    },

    setBarcode() {
      if (this.loading || this.barcodeModel?.length !== 13) return

      this.loading = true
      this.errorMsg = ''

      this.$emit('cart:check-product-barcode', this.barcodeModel)
    }
  }
}
</script>

<style scoped>
:deep(.v-text-field__slot) {
  min-height: 120px;
  display: flex !important;
  align-items: center !important;
}

:deep(.v-text-field input) {
  font-size: 36px;
  min-height: 70px;
  text-align: left;
}

:deep(.v-text-field .v-label) {
  font-size: 26px;
  min-height: 30px;
  line-height: 30px;
}
</style>
